var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.clone
    ? _c("div", { staticClass: "block-editor ai-bot-response payload" }, [
        _c(
          "div",
          { staticClass: "says" },
          [
            _c("TiptapEditor", {
              key: "tiptap-prompt" + _vm.renderKey,
              attrs: {
                "show-emoji": true,
                "show-attributes": true,
                placeholder: _vm.$t("automation.botScenario"),
                "max-character-count": 6200,
                "automation-mode": "",
              },
              model: {
                value: _vm.clone.prompt,
                callback: function ($$v) {
                  _vm.$set(_vm.clone, "prompt", $$v)
                },
                expression: "clone.prompt",
              },
            }),
          ],
          1
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }